module.exports = __webpack_public_path__ + "static/media/Bus.4efcf3d3.svg";